// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Configuración de Firebase de tu proyecto
const firebaseConfig = {
  apiKey: "AIzaSyAOoR1z2AYhAXxNK7KhbQ4jdrW8hImhl8c",
  authDomain: "dr-creators.firebaseapp.com",
  projectId: "dr-creators",
  storageBucket: "dr-creators.firebasestorage.app",
  messagingSenderId: "954055242576",
  appId: "1:954055242576:web:e15563e1be84f1ccb47255"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta Firestore y Auth para usar en la app
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, auth, storage };
